module.exports = __webpack_public_path__ + "img/summit-tablet-and-mobile.fef0806a.jpg";